module.exports = __webpack_public_path__ + "img/jgys.662ff2c3.png";